export default "__VITE_ASSET__CqbXD7Z9__"